import { withPlugins, inview } from '@spon/plugins';

function FadeIn({ node, plugins: { inview } }) {
	const prefersReducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	const fadeElements = [...node.querySelectorAll('[data-fade-in]')];

	if (prefersReducedMotion) {
		fadeElements.forEach(el => el.classList.add('has-moved'));
		return;
	}

	inview.settings = {
		rootMargin: '0px 0px -40% 0px',
	};

	inview.observe(fadeElements, {
		enter: ({ target }) => {
			if (!target.classList.contains('has-moved')) {
				target.classList.add('has-moved');
			}
		},
	});
}
export default withPlugins(inview)(FadeIn);
